import { render, staticRenderFns } from "./normal_layout.vue?vue&type=template&id=395e4e22&scoped=true&"
import script from "./normal_layout.vue?vue&type=script&lang=js&"
export * from "./normal_layout.vue?vue&type=script&lang=js&"
import style0 from "./normal_layout.vue?vue&type=style&index=0&id=395e4e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e4e22",
  null
  
)

export default component.exports